module.exports = __webpack_public_path__ + "img/tour.88c2ff1c.png";